<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="realy-content">
        <div class="qrCode-box">
          <div v-for="(item, idx) in info" :key="idx">
            <img class="idCard-img" :src="item.images" alt="" />
            <!-- <div class="print-btn" @click="printPdfFile(item)">打印</div> -->
            <div style="width: 100%; height: 35rem"></div>
          </div>
        </div>
      </div>
      <div class="load-mask" id="loadDom" v-if="maskShow"></div>
    </div>
    <Back :print="print" @toPrintEve="printPdfFile" />
    <div class="lt-mask" v-if="failShow" @click="failShow = false">
      <div class="ly-body" @click.stop="">
        <div class="lt-item">未查询到该证照(证明)信息</div>
        <div class="cl-btn" @click="goBackFail">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import lodop from "@/assets/js/doPrint.js";
import { Loading } from "element-ui";
export default {
  name: "",
  data() {
    return {
      info: [],
      loadingInstance: null,
      waitTime: 180,
      watiTimer: null,
      print: "1", //打印按钮
      inquireNum: 0, //请求次数
      failShow: false, //未查询到证照提示
      // type: "",//1公积金 2 社保
      maskShow: false,
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
    };
  },
  created() {
    // this.info.push(JSON.parse(localStorage.getItem("asdfgh")))
    // this.info = JSON.parse(localStorage.getItem("asdfgh"));
    // this.info.forEach(el => {
    //   el.images = "data:image/jpeg;base64," + el.imgbase64;
    // })
    // this.info.images = "data:image/jpeg;base64," + this.info.imgbase64;
  },
  mounted() {
    this.timeDown();
    var type = this.$route.query.type;
    this.maskShow = true;
    // setTimeout(() => {
    //   this.loadingInstance = Loading.service({ fullscreen: true, text: '正在查询...', target: document.querySelector('#loadDom') });
    // }, 500);
    var localList =
      JSON.parse(localStorage.getItem(this.$store.state.suerInfo.cerno)) || [];
    var have = false;
    if (type == "1") {
      localList.forEach((el) => {
        if (el.class == "gjj") {
          have = true;
          this.info = el.list;
          this.print = "2";
          this.maskShow = false;
        }
      });
      if (!have) {
        // setTimeout(() => {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在查询...",
          target: document.querySelector("#loadDom"),
        });
        // }, 500);
        // 公积金
        this.getGJJinfo();
      }
    } else if (type == "2") {
      localList.forEach((el) => {
        if (el.class == "sb") {
          have = true;
          this.info = el.list;
          this.print = "2";
          this.maskShow = false;
        }
      });
      if (!have) {
        setTimeout(() => {
          this.loadingInstance = Loading.service({
            fullscreen: true,
            text: "正在查询...",
            target: document.querySelector("#loadDom"),
          });
        }, 500);
        // 社保
        this.getSBinfo();
      }
    } else {
      localList.forEach((el) => {
        if (el.class == "yb") {
          have = true;
          this.info = el.list;
          this.print = "2";
          this.maskShow = false;
        }
      });
      if (!have) {
        setTimeout(() => {
          this.loadingInstance = Loading.service({
            fullscreen: true,
            text: "正在查询...",
            target: document.querySelector("#loadDom"),
          });
        }, 500);
        // 医保
        this.getYBinfo();
      }
    }
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
      // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
  },
  destroyed() {
    localStorage.removeItem("asdfgh");
    clearTimeout(this.watiTimer);
  },
  methods: {
    goBackFail() {
      this.failShow = false;
      this.$router.back();
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 180;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
    printPdfFile(item) {
      this.$rqt.print_save({
        type: this.$route.query.title,
        fmac: this.fmac,
        name: this.name,
        phone: this.phone,
        idCard: this.idCard,
      });
      this.maskShow = true;
      setTimeout(() => {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在打印...",
          target: document.querySelector("#loadDom"),
        });
      }, 500);
      // console.log(item);
      // lodop.zzPrint(item.images)
      this.info.forEach((el) => {
        // lodop.zzPrint(el.images)
        this.localPrint(el.printImg);
      });
      setTimeout(() => {
        this.maskShow = false;
        this.loadingInstance.close();
      }, 16000);
    },
    localPrint(base64String) {
      this.$rqt.localhost_print({
        base64String,
      });
    },
    // 公积金信息
    getGJJinfo() {
      this.$rqt
        .gjjapi_selectNameGetgJJ({
          type: "1",
          name: this.$store.state.suerInfo.name,
          idCard: this.$store.state.suerInfo.cerno,
          // idCard: "370705199008300062"
        })
        .then((res) => {
          if (res.code == 200) {
            var data = JSON.parse(res.data.msg);
            this.pdfToimg(data.body.data);
          } else {
            this.inquireNum = 0;
            this.loadingInstance.close();
            this.failShow = true;
          }
        });
      // this.$rqt
      //   .getGjj(localStorage.getItem("KWYSTOKEN"))
      //   .then((res) => {
      //     if (res.code == 200) {
      //       this.inquireNum = 0
      //       // var arr = []
      //       // arr.push(res.rsdata[0].body)
      //       var arr = res.rsdata[0].imgbase64
      //       this.info = arr;
      //       this.info.forEach(el => {
      //         el.images = "data:image/jpeg;base64," + el.pic;
      //         el.printImg = el.pic
      //       })
      //       this.loadingInstance.close();
      //       this.print = '2'
      //       this.maskShow = false
      //       var cerno = this.$store.state.suerInfo.cerno
      //       var localList = JSON.parse(localStorage.getItem(cerno)) || []
      //       var local = {
      //         class: "gjj",
      //         list: this.info
      //       }
      //       localList.push(local)
      //       localStorage.setItem(cerno, JSON.stringify(localList))
      //     } else {
      //       if (this.inquireNum < 5) {
      //         this.inquireNum++
      //         this.getGJJinfo()
      //       } else {
      //         this.inquireNum = 0
      //         this.loadingInstance.close();
      //         this.failShow = true;
      //       }
      //     }
      //   })
      //   .catch(() => {
      //     if (this.loadingInstance) {
      //       this.loadingInstance.close();
      //     }
      //     this.failShow = true;
      //   });
    },
    pdfToimg(base64) {
      this.$rqt.gjjapi_decryptBase64({ base64 }).then((res) => {
        this.info;
        res.data.forEach((el) => {
          this.info.push({
            images: el,
            printImg: el.replace("data:image/png;base64,", ""),
          });
        });
        this.loadingInstance.close();
        this.print = "2";
        this.maskShow = false;
        var cerno = this.$store.state.suerInfo.cerno;
        var localList = JSON.parse(localStorage.getItem(cerno)) || [];
        var local = {
          class: "gjj",
          list: this.info,
        };
        localList.push(local);
        localStorage.setItem(cerno, JSON.stringify(localList));
      });
    },
    // 社保信息
    getSBinfo() {
      this.$rqt
        .getShbx(localStorage.getItem("KWYSTOKEN"))
        .then((res) => {
          if (res.code == 200) {
            this.inquireNum = 0;
            var arr = [];
            res.JPGBase64.forEach((el) => {
              var obj = {
                imgbase64: el.pic,
                data: res.PdfBase64,
              };
              arr.push(obj);
            });
            this.info = arr;
            this.info.forEach((el) => {
              el.images = "data:image/jpeg;base64," + el.imgbase64;
              el.printImg = el.imgbase64;
            });
            this.loadingInstance.close();
            this.print = "2";
            this.maskShow = false;
            var cerno = this.$store.state.suerInfo.cerno;
            var localList = JSON.parse(localStorage.getItem(cerno)) || [];
            var local = {
              class: "sb",
              list: this.info,
            };
            localList.push(local);
            localStorage.setItem(cerno, JSON.stringify(localList));
          } else {
            if (this.inquireNum < 5) {
              this.inquireNum++;
              this.getSBinfo();
            } else {
              this.inquireNum = 0;
              this.loadingInstance.close();
              this.failShow = true;
            }
          }
        })
        .catch(() => {
          if (this.inquireNum < 5) {
            this.inquireNum++;
            this.getSBinfo();
          } else {
            this.inquireNum = 0;
            this.loadingInstance.close();
            this.failShow = true;
          }
        });
    },
    // 医保
    getYBinfo() {
      this.$rqt
        .getPrintPsnInsuProv(localStorage.getItem("KWYSTOKEN"))
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.inquireNum = 0;
            var arr = [];
            arr.push({
              imgbase64: res.msg,
            });
            this.info = arr;
            this.info.forEach((el) => {
              el.images = "data:image/jpeg;base64," + el.imgbase64;
              el.printImg = el.imgbase64;
            });
            this.loadingInstance.close();
            this.print = "2";
            this.maskShow = false;
            var cerno = this.$store.state.suerInfo.cerno;
            var localList = JSON.parse(localStorage.getItem(cerno)) || [];
            var local = {
              class: "yb",
              list: this.info,
            };
            localList.push(local);
            localStorage.setItem(cerno, JSON.stringify(localList));
          } else {
            if (this.inquireNum < 5) {
              this.inquireNum++;
              this.getYBinfo();
            } else {
              this.inquireNum = 0;
              this.loadingInstance.close();
              this.failShow = true;
            }
          }
        })
        .catch(() => {
          if (this.loadingInstance) {
            this.loadingInstance.close();
          }
          this.failShow = true;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 70%;
  height: calc(100vh - 42rem - 40px);
  /* min-height: calc(100vh - 40px); */
  padding: 20px;
  margin: auto;
  background-color: #fff;
  /* overflow: scroll; */
  /* display: flex; */
  position: relative;
}

/* .content::-webkit-scrollbar {
  display: none;
} */

.realy-content {
  width: 100%;
  height: calc(100vh - 42rem - 40px);
  overflow: scroll;
}

.realy-content::-webkit-scrollbar {
  display: none;
  /* 对于Chrome, Safari和Opera */
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.qrCode-box {
  margin: auto;
  text-align: center;
}

.idCard-img {
  width: 180rem;
  margin-bottom: 2rem;
}

.print-btn {
  width: 34rem;
  height: 17rem;
  line-height: 17rem;
  background-color: rgb(34, 167, 244);
  color: #ffffff;
  text-align: center;
  border-radius: 10px;
  font-size: 7rem;
  cursor: pointer;
  margin: auto;
}

.print-btn:active {
  background-color: rgba(34, 167, 244, 0.5);
}

.lt-mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  background-color: rgba(0, 0, 0, 0.6);

  .ly-body {
    background-color: #fff;
    margin: auto;
    padding: 12rem;
    border-radius: 3rem;
    text-align: center;

    .lt-item {
      font-size: 8rem;
      margin-bottom: 2rem;

      .ipt {
        font-size: 8rem;
      }
    }

    .cl-btn {
      width: fit-content;
      margin: 6rem auto 0;
      padding: 3rem 6rem;
      background-color: #295eb5;
      font-size: 7rem;
      color: #ffffff;
      border-radius: 3rem;
    }

    .submit-btn {
      background-color: #24b34c;
    }

    .wxcode-img {
      display: block;
      margin: auto;
      width: 70rem;
      height: 70rem;
    }
  }
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
